// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1dDWf","savePackageButton":"ClientWallet_savePackageButton__1PCdJ"};